
import { configureStore } from "@reduxjs/toolkit";
import itemsReducer from "./Features/Items/ItemSlice";

import offerReducer from "./Features/offers/OfferSlice";
import eventReducer from "./Features/Events/EventSlice";
import productReducer from "./Features/Product/ProductSlice";
import cartReducer from "../src/Features/services/cartSlice";
import offersReducer from "../src/Features/Offer/offerSlice";
import orderReducer from "../src/Features/services/orderSlice";
import authReducer from "../src/Features/services/authSlice";
import messageReducer from '../src/Features/message/messageSlice'
import { api } from "./Api/api";

export const store = configureStore({
  reducer: {
    items: itemsReducer,
    auth: authReducer,
    offers: offerReducer,
    events: eventReducer,
    products: productReducer,
    cart: cartReducer,
    offer: offersReducer,
    order: orderReducer,
    message: messageReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
